// extracted by mini-css-extract-plugin
module.exports = {"edit":"EditPencil_edit__2xnDz","pencil":"EditPencil_pencil__1O9b6"};